import React from 'react'

function PreSurgeDamper() {
  return (
    <embed src="\pdfs\E2.5_rk-f10_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default PreSurgeDamper